import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcFilter24 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m8.031 12.969c1.719 0 3.375 1.218 3.844 3.031h9.094c.562 0 1 .469 1 1 0 .562-.438 1-1 1h-9.063c-.437 1.75-2 2.969-3.875 2.969-1.844 0-3.437-1.188-3.875-2.969h-1.156c-.531 0-1-.438-1-1 0-.531.469-1 1-1h1.156c.469-1.75 2.063-3.031 3.875-3.031zm-.031 2.031c-1.125 0-2 .938-2 2 0 1.125.906 2 2 2s2-.875 2-2c0-1.094-.906-2-2-2zm8.031-12a4.044 4.044 0 0 1 3.875 3h1.094c.563 0 1 .469 1 1 0 .563-.438 1-1 1h-1.094c-.437 1.75-2 3-3.875 3-1.812 0-3.437-1.219-3.875-3h-9.156c-.563 0-1-.438-1-1 0-.531.438-1 1-1h9.156c.469-1.75 2.063-3 3.875-3zm-.031 2c-1.094 0-2 .906-2 2s.906 2 2 2 2-.875 2-2c0-1.094-.906-2-2-2z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcFilter24;
